import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppUserModel } from 'features/app_user/data/AppUserModel';
import { AppThunk, RootState } from 'app/store';
import { AppUserFromModel } from 'features/app_user/domain/AppUser';
// import Firebase from 'core/firebase/Firebase';
import { logout } from 'features/app_user/auth/authSlice';
import { isLicenseValid } from 'utils/appUserUtils';
// import { logger } from 'codelyzer/util/logger';
import PocketBase from 'pocketbase';
import { pocketBase } from 'config';

export interface AppUserState {
    appUser: AppUserModel | undefined;
}

const initialState: AppUserState = {
    appUser: undefined
};

export const appUserSlice = createSlice({
    name: 'appUser',
    initialState,
    reducers: {
        onLogout: () => { return { appUser: undefined } },
        onLoginSuccess: (state: AppUserState, action: PayloadAction<AppUserModel>) => {
            return { ...state, appUser: action.payload }
        }
    }
});


export const watchUserData = (nr: string): AppThunk => async (dispatch) => {

    const pb = new PocketBase(pocketBase.url);
    // console.log(nr, pb.authStore.token)
    const currentUserId = pb.authStore.token;
    const currentUserAppData = pb.authStore.record?.appData ?? [];
    const currentUserAppDataBackup = pb.authStore.record?.backups ?? [];
    // const appUserLocal = JSON.parse(await localStorage.getItem('persist:root') ?? '');
    const hasDataLoad = false // JSON.parse(await localStorage.getItem('loadData') ?? 'false');


    // console.log('watchUserData', { appUserLocal, hasDataLoad, l: currentUserAppData.length })

    if (!currentUserId) {
        // console.log('#### watchUserData !currentUserId logout');
        // smmd App Logout bei Anpassungen verhindern
        // dispatch(logout());
        return;
    }
    try {
        // appData
        const appData: any = [];
        if (!hasDataLoad && currentUserAppData.length > 0) {
            // console.log('currentUserAppData', currentUserAppData)
            const filterData = currentUserAppData.length > 0
                ? ('id = "' + currentUserAppData.join('" || id = "')) + '"'
                : ''
            if (filterData !== '') {
                const records = await pb.collection('appData').getList(1, 50, {
                    sort: '-backupDate',
                    filter: filterData,
                });
                (records.items ?? []).forEach((aD: any) => {
                    appData[aD.title] = aD
                });
            }
        }

        // backups
        const appDataBackup: any = [];
        if (!hasDataLoad && currentUserAppDataBackup.length > 0) {
            const filterDataBackup = currentUserAppDataBackup.length > 0
                ? ('id = "' + currentUserAppDataBackup.join('" || id = "')) + '"'
                : ''
            // console.log(filterDataBackup)
            if (filterDataBackup !== '') {
                const recordsBackup = await pb.collection('appDataBackup').getList(1, 50, {
                    sort: '-backupDate',
                    filter: filterDataBackup,
                });
                (recordsBackup.items ?? []).forEach((aD: any) => {
                    appDataBackup[aD.title] = aD
                });
            }
        }

        const appUser = { ...pb.authStore.record as any, appData, backups: appDataBackup } as AppUserModel

        // const appUser: AppUserModel = pb.authStore.record as any as AppUserModel;

        localStorage.setItem('loadData', JSON.stringify('false'))


        // const diff = ((Date.now() - (appUser.lastLogin ?? 0)) / 1000) / 60 / 60 / 24

        // console.log('####1#', diff, (appUser.lastLogin ?? 0))

        // Logout 30 Tage
        // if (diff > 30) {
        //     dispatch(logout());
        //     return;
        // }

        if (!isLicenseValid(appUser)) {
            // console.log('watchUserData isLicenseValid logout');
            dispatch(logout());
            return;
        }

        dispatch(AppUserActions.onLoginSuccess(appUser));
        // setTimeout(() => {
        //     dispatch(watchUserData('#2'));
        // }, 1000)
    } catch (err) {
        console.error(err);
    }
};

export const getAppUser = createSelector(
    (state: RootState) => state.appUser.appUser,
    (appUserModel) => AppUserFromModel(appUserModel)
);
export const isAuthenticated = createSelector(
    (state: RootState) => state.appUser.appUser,
    (appUserModel) => appUserModel !== undefined
);

export const AppUserActions = appUserSlice.actions;
export default appUserSlice.reducer;
